const de = {

    message: {

        title1: 'Fernsteuerung von Smart Home, Technologie, Sicherheit und Seelenfrieden',

        content1: ' Mit AigoSmart können Sie Smart-Home-Geräte aus der Ferne verwalten und steuern. Die Geräte können sich auch gegenseitig wahrnehmen und verknüpfen. Durch Auslösen mit einem Klick können verschiedene Haushaltsgeräte in Ihren voreingestellten Zustand versetzt werden, wodurch ein sicheres und sorgenfreies Smart-Home für Sie entsteht Leben.',

        title2: "AigoSmart ist eine neue Untermarke von Aigostar",

        content2: "Die Produkte werden derzeit nach Spanien, Portugal, Frankreich, Italien, den Niederlanden, Deutschland, Finnland, Dänemark, Polen, Russland, Griechenland, Österreich, der Schweiz, der Tschechischen Republik, Ungarn, der Slowakei und anderen europäischen Ländern und Regionen verkauft.",

        content3: " Die verschiedenen Küchen-, Wäsche- und Bügelkleingeräte von AIGOSTAR belegen weiterhin",

        content4: " Top Ten Verkäufe",

        title3: "Brand Honor",

        content5: "Schnell. Öffnen. Innovieren. Durchhalten",

        loading: 'Laden',

        submit: 'Absenden',

        contactUs: "Kontakt",

        privacy: "Datenschutzvereinbarung",

        policy: "Servicerichtlinie",

        download: "Download",



    },

    "wisdomleads": {
        "title1": "Fernsteuerung von Smart Home, Technologie, Sicherheit und Sorge",
        "content1": "wisdomleads hilft Ihnen, intelligente Haushaltsgeräte fernzuhalten und zu steuern. Geräte können auch miteinander wahrnehmen und interagieren. Ein Klick-Auslöser kann alle Arten von Haushaltsgeräten in Ihren voreingestellten Zustand versetzen und ein sicheres und sorgenfreies Smart Home Leben für Sie schaffen.",
        "title2": "wisdomleads ist eine neue Submarke von aigostar",
        "content2": "Derzeit werden die Produkte nach Spanien, Portugal, Frankreich, Italien, den Niederlanden, Deutschland, Finnland, Dänemark, Polen, Russland, Griechenland, Österreich, Schweiz, Tschechien, Ungarn, Slowakei und anderen europäischen Ländern und Regionen verkauft.",
        "content3": "Aigostar hat eine Vielzahl von Küche und Waschen und Bügeln von kleinen Haushaltsgeräten",
        "content4": "Top 10-Verkäufe.",
        "title3": "Markenehre",
        "content5": "Schnell zu öffnen. Innovation bestehen",
        "loading": "Laden",
        "submit": "Absenden",
        "contactUs": "Kontaktieren Sie uns",
        "privacy": "Datenschutzvereinbarung",
        "policy": "Dienstleistungspolitik",
        "download": "Download"
    },

    "v119": {
        "password": "Passwort",
        "back": "zurück",
        "account": "Konto ausfüllen",
        "VerifyAccount": "Konto verifizieren",
        "confire": "bestätigen",
        "complete": "komplett",
        "loginAccount": "Login-Konto",
        "VerifyCode": "Prüfcode",
        "preview": "Vorheriger Schritt",
        "next": "Nächster Schritt",
        "enterEmail": "E-Mail eingeben",
        "phone": "Mobile Anmeldung",
        "email": "E-Mail-Anmeldung",
        "pleaseenter": "Bitte geben Sie ein",
        "emailError": "Fehler im E-Mail-Format",
        "phoneError": "Fehler beim Formatieren von Mobilfunknummern",
        "qcCodeError": "Fehler im Verifizierungscode",
        "sendCode": "Bestätigungscode senden",
        "reSend": "Wiedersenden",
        "tip1": "Bevor Sie den Widerrufsantrag einreichen, überprüft die Plattform die folgenden Informationen, um die Sicherheit Ihres Kontos und Ihrer Immobilie zu gewährleisten:",
        "tip2": "Das Konto befindet sich in einem sicheren Zustand",
        "tip3": "Keine sensiblen Vorgänge wie das Binden von Mobiltelefonen/E-Mails, Ändern von Passwörtern, Ändern von Anmeldegeräten usw. innerhalb von 15 Tagen",
        "tip4": "Konto hat keine laufenden Smart Devices",
        "tip5": "Sie sind offline (oder ungebunden) auf Ihrem Smart-Gerät",
        "tip6": "Konto hat kein Vermögensrisiko",
        "tip7": "Keine sensiblen Vorgänge wie Ändern von Passwörtern, Kauf von Aufzeichnungen oder Bindung von Bankkarten innerhalb von 15-Tagen",
        "accountCancellation": "Kontoauflösung",
        "tip8": "Danke für Ihre ständige Gesellschaft. Leider kann AigoSmart Ihnen keine Dienste mehr anbieten. Bevor Sie Ihr Konto kündigen, überprüfen wir Ihr Konto erneut. Bitte beachten Sie, dass die folgenden Informationen nach erfolgreicher Kündigung gelöscht werden.",
        "tip9": "Danke für Ihre ständige Gesellschaft. Leider kann Wisdomleads Ihnen keine Dienste mehr anbieten. Bevor Sie Ihr Konto kündigen, überprüfen wir Ihr Konto erneut. Bitte beachten Sie, dass die folgenden Informationen nach erfolgreicher Kündigung gelöscht werden.",
        "tip10": "1. Intelligente Modul-, Raum-, Haus- und Gerätenetzwerkinformationen werden dauerhaft gelöscht und können nicht wiederhergestellt werden",
        "tip11": "2. Szenarien, Automatisierung, benutzerdefinierte Rezepte und andere Informationen werden dauerhaft gelöscht und können nicht wiederhergestellt werden",
        "tip13": "3. Alle Kontoinformationen, Serviceaufzeichnungen, Verbrauchsstatus und andere Informationen auf der Plattform werden dauerhaft gelöscht und können nicht wiederhergestellt werden",
        "tip14": "4. Sie können sich nicht anmelden und dieses AigoSmart-Konto verwenden. Ihre Familie/Freunde können über dieses Konto keine Geräte mit Ihnen teilen",
        "tip14w": "4. Sie können sich nicht anmelden und dieses Wisdomleads-Konto verwenden. Ihre Familie/Freunde können über dieses Konto keine Geräte mit Ihnen teilen",
        "tip15": "5. Die persönlichen Informationen und historischen Nachrichten Ihres AigoSmart-Kontos (einschließlich Avatar, Nickname, Gerätealarminformationen, Plattform Push, Familiennachrichten usw.) werden nicht abgerufen",
        "tip15w": "5. Die persönlichen Informationen und historischen Nachrichten Ihres Wisdomleads-Kontos (einschließlich Avatare, Nicknamen, Gerätealarminformationen, Plattform Push, Familiennachrichten usw.) werden nicht abgerufen",
        "tip16": "6. Bevor Sie dieses Konto nutzen, müssen Sie das Guthaben des Kontos ordnungsgemäß handhaben (Punkte, Mitgliedschaftsstufe, Qualifikationen, Bestellungen, Gutscheine, Requisiten und andere wertvolle Dienstleistungen). Die Kündigung des Kontos gilt als eigenständiges Aufgeben und nicht in der Lage sein, es weiter zu nutzen. Sie verstehen und stimmen zu, dass AigoSmart Ihnen nicht bei der Wiederherstellung der oben genannten Dienste helfen kann.",
        "tip16w": "6. Bevor Sie dieses Konto nutzen, müssen Sie das Guthaben des Kontos ordnungsgemäß handhaben (Punkte, Mitgliedschaftsstufe, Qualifikationen, Bestellungen, Gutscheine, Requisiten und andere wertvolle Dienstleistungen). Die Kündigung des Kontos gilt als eigenständiges Aufgeben und nicht in der Lage sein, es weiter zu nutzen. Sie verstehen und stimmen zu, dass Wisdomleads Ihnen nicht bei der Wiederherstellung der oben genannten Dienste helfen kann.",
        "tip17": "Die Plattform wird Ihre Bewerbung bearbeiten und alle Ihre Daten innerhalb von 15 Tagen löschen. Bitte melden Sie sich nicht innerhalb von 15-Tagen bei der Plattform an, um eine erfolgreiche Abmeldung zu gewährleisten",
        "tip18": "Bitte geben Sie den Bestätigungscode ein",
        "tip12": "Sie können sich derzeit nicht abmelden",
        "tip20": "Vorschläge für die Plattform (optional)",
        "errorMsg1": "Benutzer existiert nicht",
        "errorMsg2": "Der Benutzer hat eine Stornierung beantragt",
        "errorMsg3": "Es ist Benutzern untersagt, sich aufgrund riskanter Vorgänge innerhalb von 15-Tagen abzumelden, z. B. Passwortwechsel, Gerätewechsel usw.",
        "errorMsg4": "Falscher Prüfcode",
        "tip21": "Bitte warten Sie, die Mensch-Maschine-Verifizierung ist im Gange"
    }

}



export default de;